/**
 * Player model
 */

import { Action, SetupActionData } from './Action';
import { CustomProperty, SetupCustomPropertyData } from './CustomProperty';

// Forward declaration
declare function ArrayCloneForDiff(arr: any[]): any[];

export class Player {
    Gender: string = "Male";
    Name: string = "";
    Description: string = "";
    StartingRoom: string | null = null;
    CurrentRoom: string | null = null;
    PlayerGender: string = "Male";
    bPromptForName: boolean = false;
    bPromptForGender: boolean = false;
    PlayerPortrait: string = "";
    PlayerLayeredImage: string = "";
    Actions: Action[] = [];
    ActionsUseAdvanced: boolean = false;
    bEnforceWeight: boolean = false;
    dWeightLimit: number = 100.5;
    CustomProperties: CustomProperty[] = [];

    cloneForDiff(): {
        Name: string;
        Description: string;
        CurrentRoom: string | null;
        PlayerGender: string;
        PlayerPortrait: string;
        PlayerLayeredImage: string;
        Actions: any[];
        CustomProperties: any[];
    } {
        return {
            Name: this.Name,
            Description: this.Description,
            CurrentRoom: this.CurrentRoom,
            PlayerGender: this.PlayerGender,
            PlayerPortrait: this.PlayerPortrait,
            PlayerLayeredImage: this.PlayerLayeredImage,
            Actions: (window as any).ArrayCloneForDiff?.(this.Actions) || this.Actions.slice(),
            CustomProperties: (window as any).ArrayCloneForDiff?.(this.CustomProperties) || this.CustomProperties.slice(),
        };
    }
}

export function SetupPlayerData(GameData: any[]): Player {
    const ThePlayer = new Player();
    ThePlayer.Name = GameData[0];
    ThePlayer.Description = GameData[1];
    ThePlayer.StartingRoom = GameData[2];
    ThePlayer.PlayerGender = GameData[3];
    ThePlayer.PlayerLayeredImage = GameData[4];
    ThePlayer.bPromptForName = GameData[5];
    ThePlayer.bPromptForGender = GameData[6];
    ThePlayer.PlayerPortrait = GameData[7];
    ThePlayer.bEnforceWeight = GameData[8];
    ThePlayer.dWeightLimit = GameData[9];

    for (let i = 0; i < GameData[10].length; i++) {
        ThePlayer.CustomProperties.push(SetupCustomPropertyData(GameData[10][i]));
    }

    for (let j = 0; j < GameData[11].length; j++) {
        ThePlayer.Actions.push(SetupActionData(GameData[11][j]));
    }

    ThePlayer.ActionsUseAdvanced = Boolean(GameData[12]);
    return ThePlayer;
}
